import { getClientConfigForEnv, type ClientConfig } from '@/client_config';
import { useConfigStore } from '@/stores';

/**
 * Returns a readonly bundled client configuration for the current deployment, keyed off {@link useConfigStore}'s `env`.
 *
 * Delegates to {@link getClientConfigForEnv}: missing `env` → dev JSON; if `env` includes `"stage"` → stage
 * (checked before `"dev"` so values like `develop-stage-1` resolve to stage); else if it includes `"dev"` → dev;
 * otherwise → prod.
 *
 * @function
 * @returns {Readonly<ClientConfig>} The dev, stage, or prod client config object.
 */
export const useClientConfig = (): Readonly<ClientConfig> => {
  const { env } = useConfigStore();
  return getClientConfigForEnv(env);
};
